import { render } from "./app-icon-invalid-link.vue?vue&type=template&id=8810b6de"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-invalid-link.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8810b6de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8810b6de', __exports__)) {
    console.log('reload')
    api.reload('8810b6de', __exports__)
  }
  
  module.hot.accept("./app-icon-invalid-link.vue?vue&type=template&id=8810b6de", () => {
    console.log('re-render')
    api.rerender('8810b6de', render)
  })

}


export default __exports__